/* TRIO – En-tête XL */
(function () {
  'use strict';
  if (window.__trioHd) return;
  window.__trioHd = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ann(root) {
    root.querySelectorAll('[data-tw-ann]').forEach(function (a) {
      var msgs = a.querySelectorAll('.tw-ann__msg'), k = 0;
      document.documentElement.style.setProperty('--tw-ann-h', a.offsetHeight + 'px');
      if (msgs.length < 2 || reduce) return;
      setInterval(function () {
        var cur = msgs[k]; k = (k + 1) % msgs.length; var nx = msgs[k];
        cur.classList.remove('is-on'); cur.classList.add('is-out');
        nx.classList.remove('is-out'); nx.classList.add('is-on');
        setTimeout(function () { cur.classList.remove('is-out'); }, 650);
      }, 3800);
    });
  }

  function hd(root) {
    root.querySelectorAll('[data-tw-hd]').forEach(function (h) {
      if (!document.querySelector('[data-tw-ann]')) document.documentElement.style.setProperty('--tw-ann-h', '0px');
      var wrap = document.querySelector('.page-wrapper');
      function y() { return Math.max(window.scrollY || 0, wrap ? wrap.scrollTop : 0); }
      function onScroll() { h.classList.toggle('is-scrolled', y() > 12); }
      document.addEventListener('scroll', onScroll, { passive: true, capture: true }); onScroll();

      /* Pastille qui suit le survol */
      var nav = h.querySelector('.tw-hd__nav'), ind = h.querySelector('.tw-hd__ind');
      if (nav && ind) {
        var links = nav.querySelectorAll('.tw-hd__link');
        var move = function (el) {
          if (!el) { ind.style.opacity = 0; return; }
          var r = el.getBoundingClientRect(), n = h.querySelector('.tw-hd__pill').getBoundingClientRect();
          ind.style.left = (r.left - n.left) + 'px'; ind.style.width = r.width + 'px'; ind.style.opacity = 1;
        };
        links.forEach(function (l) { l.addEventListener('mouseenter', function () { move(l); }); l.addEventListener('focus', function () { move(l); }); });
        nav.addEventListener('mouseleave', function () { move(nav.querySelector('.tw-hd__link[aria-current="page"]')); });
      }

      /* Méga-menu au clavier / tactile */
      h.querySelectorAll('.tw-hd__item').forEach(function (it) {
        var t = it.querySelector('.tw-hd__link');
        t.addEventListener('keydown', function (e) { if (e.key === 'Escape') { it.classList.remove('is-open'); t.blur(); } });
        it.addEventListener('mouseleave', function () { it.classList.remove('is-open'); });
      });

      /* Menu mobile */
      var b = h.querySelector('.tw-hd__burger'), menu = h.querySelector('.tw-menu');
      if (b && menu) {
        var set = function (open) {
          h.classList.toggle('is-menu', open);
          b.setAttribute('aria-expanded', open ? 'true' : 'false');
          b.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
          document.documentElement.style.overflow = open ? 'hidden' : '';
          menu.querySelectorAll('.tw-menu__links a span').forEach(function (s, i) { s.style.transitionDelay = open ? (0.06 + i * 0.06) + 's' : '0s'; });
        };
        b.addEventListener('click', function () { set(!h.classList.contains('is-menu')); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
        menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { set(false); }); });
      }

      /* Petit rebond du panier quand il change */
      document.addEventListener('cart:update', function () {
        var c = h.querySelector('.tw-hd__cart'); if (!c) return;
        c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump');
      });
    });
  }

  function init(root) { root = root || document; ann(root); hd(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
